var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { FormBeneficiaryAFY, ModalComponentAFY, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
export var ModalInsurance = function (props) {
    var openModal = props.openModal, setOpenModal = props.setOpenModal, isMaskedDocument = props.isMaskedDocument, dataFormInsurance = props.dataFormInsurance, titleInsured = props.titleInsured, insuredType = props.insuredType, listIdentificationType = props.listIdentificationType, handleSubmitInsured = props.handleSubmitInsured, searchInsurancePerson = props.searchInsurancePerson, t = props.t;
    return (_jsx(ModalComponentAFY, __assign({ openModal: openModal, backgroundColor: "#ffffff", onClose: function () { return setOpenModal(false); }, border: 0, modalWidth: 986, padding: 40, modalHeight: "90%" }, { children: _jsx(FormBeneficiaryAFY, { isntMaskedDocument: isMaskedDocument, dataForm: dataFormInsurance, onClickAcquire: function noRefCheck() { }, onClickCancel: function () { return setOpenModal(false); }, onClickSave: function noRefCheck() { }, onNext: handleSubmitInsured, 
            // onNext={(e) => console.log("DATAFORM", e)}
            openModal: true, subtitle: t("confirmationData.subtitleBeneficiary"), title: titleInsured, typeInsuredOption: insuredType, TypeList: listIdentificationType, formsCompleted: [true, false, false], onBlurDocument: function (event) {
                searchInsurancePerson(event);
            }, onBlurInput: function (event) {
                searchInsurancePerson(event);
            } }) })));
};
